const news = [
    {
        alias: "joandonaldsonscholars",
        navigation: [
            {
                link: "/news/joandonaldsonscholars",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/joandonaldsonscholars/about-the-joan-donaldson-cbc-news-scholarship-1.2816864",
                title: "About",
                type: "internal",
            },
            {
                link: "/news/joandonaldsonscholars/about-joan-donaldson-1.2816897",
                title: "Joan Donaldson",
                type: "internal",
            },
            {
                link: "/news/joandonaldsonscholars/2024-joan-donaldson-cbc-news-scholarship-recipients-1.7125972",
                title: "Current Recipients",
                type: "internal",
            },
            {
                link: "/news/joandonaldsonscholars/past-recipients-joan-donaldson-cbc-news-scholarship-1.2817070",
                title: "Past Recipients",
                type: "internal",
            },
        ],
    },
    {
        alias: "theinvestigators",
        description:
            "The Investigators with Diana Swain pulls back the curtain on journalism, connecting with the journalists who break big stories.",
    },
    {
        alias: "powerandpolitics",
        nestedPath: true,
        nestedUrl: "/news/politics/powerandpolitics",
        navigation: [
            {
                link: "https://gem.cbc.ca/power-politics",
                title: "Watch",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/radio/podcasts/current-affairs-information/power-politics/",
                title: "Podcast",
                type: "external",
            },
        ],
    },
    {
        alias: "theweekly",
        navigation: [
            {
                link: "/news/theweekly/the-weekly-with-wendy-mesley-1.5369744",
                title: "About the Show",
                type: "internal",
            },
            {
                link: "https://gem.cbc.ca/the-weekly",
                title: "Watch full episodes",
                type: "external",
            },
        ],
    },
    {
        alias: "the-road-ahead",
        nestedPath: true,
        nestedUrl: "/news/canada/calgary/the-road-ahead",
        navigation: [
            {
                link: "/news/canada/calgary",
                title: "Calgary",
                type: "internal",
            },
        ],
    },
    {
        alias: "being-black-in-canada",
        url: "/news/cbc-topic/Collections/Being%20black%20in%20Canada",
        title: "Being Black in Canada",
        image: "https://i.cbc.ca/1.4980365!/fileImage/httpImage/bbic.png",
        nestedPath: true,
        nestedUrl: "/news/cbc-topic/collections/being%20black%20in%20canada",
    },
    {
        alias: "1919-100-years",
        url: "/news/canada/manitoba/topic/Tag/1919%20100%20years",
        title: "1919 100 Years",
        image: "https://i.cbc.ca/1.5135227.1557847748!/fileImage/httpImage/1919-100-years.jpg",
        nestedPath: true,
        nestedUrl: "/news/canada/manitoba/topic/tag/1919%20100%20years",
    },
    {
        alias: "coping-with-covid-19",
        url: "news/covid-19/coping-with-covid-19",
        nestedPath: true,
        nestedUrl: "/news/covid-19/coping-with-covid-19",
    },
];

export default news;
